// @flow
import React from 'react';

import type { VersionProps } from './types';

const Version = ({ version }: VersionProps) => <small>Version: {version}</small>;

export default Version;
